import React, { useState } from "react";
import "../../Styles/DeepamSchemeForm.css";

const AdminDeepamSchemeForm = () => {
  const [formData, setFormData] = useState({
    headOfHousehold: "",
    relation: "",
    rationCardNumber: "",
    gasConnectionNumber: "",
    gasAgency: "",
    aadhaar: "",
    voterId:"",
    mobile: "",
    village: "",
    mandal: "",
    date: "",
    status: "",
    remarks: "",
    photo: null,
    document: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="deepam-form-container">
      <div className="deepam-form-card">
        <div className="deepam-form-header">
          <h2>Add New Deepam Scheme Beneficiary</h2>
          <p>Three free LPG cylinders every year for each eligible household</p>
          <button
            className="deepam-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="deepam-form-grid">

            <div className="deepam-form-group">
              <label>Head of Household Name *</label>
              <input
                type="text"
                name="headOfHousehold"
                placeholder="Enter Name"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Relation *</label>
              <input
                type="text"
                name="relation"
                placeholder="Ex: W/O, S/O"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Ration Card Number *</label>
              <input
                type="text"
                name="rationCardNumber"
                placeholder="Enter Ration Card Number"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Gas Connection Number *</label>
              <input
                type="text"
                name="gasConnectionNumber"
                placeholder="Enter Gas Connection Number"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Gas Agency *</label>
              <input
                type="text"
                name="gasAgency"
                placeholder="Enter Gas Agency Name"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Aadhaar Number *</label>
              <input
                type="text"
                name="aadhaar"
                placeholder="Enter 12-digit Aadhaar Number"
                maxLength="12"
                onChange={handleChange}
              />
            </div>
             <div className="deepam-form-group">
              <label>Voter Id *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter voter Id"
                maxLength="12"
                onChange={handleChange}
              />
            </div>


            <div className="deepam-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="deepam-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Approved</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="deepam-form-group">
              <label>Upload Photo *</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

            <div className="deepam-form-group">
              <label>Upload Supporting Document</label>
              <input
                type="file"
                name="document"
                accept=".pdf,image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="deepam-form-group deepam-full-width">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              placeholder="Enter Remarks"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="deepam-btn-group">
            <button type="submit" className="deepam-submit-btn">
              Submit
            </button>
            <button type="reset" className="deepam-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminDeepamSchemeForm;